/**
 * keyLeitzahl.js — Jun-2026 (User-Wunsch).
 *
 * Auto-Generierung der Schlüssel-Leitzahl (max. 4 Zeichen, manuell überschreibbar):
 *   = letzte 2 Ziffern der Fahrgestellnummer (FIN)
 *   + 2 markanteste Buchstaben des Straßennamens des Standortes
 *
 * Beispiel: FIN „…X9A47", Straße „Fürstenbrunner Weg" → „47FW".
 * Wird in der Disposition (Leitzahl-Feld) und auf der Schlüssel-QR-Karte verwendet.
 */

// Umlaute/ß transliterieren und auf A–Z reduzieren.
const toLatinUpper = (s) =>
    String(s || "")
        .replace(/ä/gi, "A").replace(/ö/gi, "O").replace(/ü/gi, "U").replace(/ß/g, "S")
        .toUpperCase();

const lettersOnly = (w) => toLatinUpper(w).replace(/[^A-Z]/g, "");

/**
 * @param {{vin?: string, street?: string}} arg
 * @returns {string} 4-stellige Leitzahl (z. B. „47FW")
 */
export function generateLeitzahl({ vin = "", street = "" } = {}) {
    const digits = String(vin || "").replace(/\D/g, "");
    const num = digits.slice(-2);

    const words = String(street || "").trim().split(/\s+/).filter(Boolean);
    let chars = "";
    if (words.length >= 2) {
        // Initialen der ersten beiden Wörter (z. B. „Fürstenbrunner Weg" → „FW")
        chars = (lettersOnly(words[0])[0] || "") + (lettersOnly(words[1])[0] || "");
    } else if (words.length === 1) {
        // Einwort-Straße → erste zwei Buchstaben (z. B. „Hauptstraße" → „HA")
        chars = lettersOnly(words[0]).slice(0, 2);
    }
    return (num + chars).slice(0, 4);
}
